import { AxiosInstance } from '../services/auth/AxiosInstance';

// ── Public ────────────────────────────────────────────────────────────────────
export const getGigs = (params) =>
  AxiosInstance.get('/gigs', { params }).then((r) => r.data);

export const getShowcaseData = () =>
  AxiosInstance.get('/gigs/showcase').then((r) => r.data);

export const getGigById = (gigId) =>
  AxiosInstance.get(`/gigs/${gigId}`).then((r) => r.data);

export const getGigBySlug = (slug) =>
  AxiosInstance.get(`/gigs/slug/${slug}`).then((r) => r.data);

export const getSimilarGigs = (gigId) =>
  AxiosInstance.get(`/gigs/${gigId}/similar`).then((r) => r.data);

export const getTags = () =>
  AxiosInstance.get('/gigs/tags').then((r) => r.data);

// ── Admin ─────────────────────────────────────────────────────────────────────
export const getAdminGigs = (params) =>
  AxiosInstance.get('/gigs/admin/all', { params }).then((r) => r.data);

export const createGig = (data) =>
  AxiosInstance.post('/gigs', data).then((r) => r.data);

export const updateGig = (gigId, data) =>
  AxiosInstance.put(`/gigs/${gigId}`, data).then((r) => r.data);

export const softDeleteGig = (gigId) =>
  AxiosInstance.delete(`/gigs/${gigId}`).then((r) => r.data);

export const hardDeleteGig = (gigId) =>
  AxiosInstance.delete(`/gigs/${gigId}/permanent`).then((r) => r.data);

export const restoreGig = (gigId) =>
  AxiosInstance.patch(`/gigs/${gigId}/restore`).then((r) => r.data);

export const toggleActive = (gigId) =>
  AxiosInstance.patch(`/gigs/${gigId}/toggle-active`).then((r) => r.data);

export const duplicateGig = (gigId) =>
  AxiosInstance.post(`/gigs/${gigId}/duplicate`).then((r) => r.data);

// ── Bookmarks ─────────────────────────────────────────────────────────────────
export const toggleBookmark = (gigId) =>
  AxiosInstance.post(`/users/bookmarks/${gigId}`).then((r) => r.data);

export const getSavedGigs = () =>
  AxiosInstance.get('/users/bookmarks').then((r) => r.data);

export const getBookmarkedIds = () =>
  AxiosInstance.get('/users/bookmarks/ids').then((r) => r.data);
